/*
* Copyright (c) 2022 LS ELECTRIC Co. Ltd. All Reserved.
*/
/*******************************************************************
 * @author JiHoon Park
 * @contact jhpark@detech.co.kr
 * @date 2022-07-19
 * @brief EHP 회사/사업장/세부사업장 개발
 *
 ********************************************************************/
import React from "react";
import ZoneView from "./ZoneView";
import NoZoneView from "./NoZoneView";
import ZoneList from "./ZoneList";
import ZoneInsert from "./ZoneInsert";
import ZoneInsertAdmin from "./ZoneInsertAdmin";
import CompZoneInsertAdmin from "./CompZoneInsertAdmin";
/**
 * @brief EHP 사업장 전기실 관리 - 회사/사업장 컴포넌트 , 반응형 동작
 * @param -
 * @returns react components
 */
function AdminZone(props) {
    //const [isMobile, setIsMobile] = useState(false);
    //const [adminType, setAdminType] = useState("ZONE"); // ZONE, SUBZONE, ROOM
    //props
    const isMobile = props.isMobile;
    const adminType = props.adminType;
    const setParentAdminType = props.setAdminType;
    const curTree = props.curTree;
    const setParentCurTree = props.setCurTree;
    const workMode = props.workMode;
    const setParentWorkMode = props.setWorkMode;
    /*
      const [curTree, setCurTree] = useState({
        company:{companyId:"", companyName:""},
        zone:{zoneId:"", zoneName:""},
        subZone:{subZoneId:"", subZoneName:""},
        room:{roomId:"", roomName:""},
        spg:{spgId:-1, spgName:""}
      });
    
    
      function handleCurTree(adminType, treeInfo) {
        clog("IN SITETREE : handleCurTree : " + adminType);
        setParentAdminType(adminType);
        setCurTree(treeInfo);
      }
    */
    //clog("IN ADMINZONE : INIT : " + isMobile + " : adminType : " + adminType + " : " + JSON.stringify(curTree));
    //clog("IN ADMINZONE : INIT : " + isMobile + " : adminType : " + adminType + " : " + workMode);
    return (React.createElement(React.Fragment, null,
        (curTree.zone.zoneId.length > 0)
            ? ((workMode === "READ") || (workMode === "INSREAD")) &&
                React.createElement(ZoneView, { isMobile: props.isMobile, workMode: props.workMode, curTree: curTree, setIsMobile: props.setIsMobile, setAdminType: props.setAdminType, setWorkMode: props.setWorkMode, setPopWin: props.setPopWin })
            : ((workMode === "READ") || (workMode === "INSREAD")) &&
                React.createElement(NoZoneView, { setIsMobile: props.setIsMobile, curTree: curTree, setPopWin: props.setPopWin }),
        (workMode === "LIST") &&
            React.createElement(ZoneList, { isMobile: props.isMobile, setIsMobile: props.setIsMobile, curTree: curTree, setCurTree: props.setCurTree, setWorkMode: props.setWorkMode, setPopWin: props.setPopWin }),
        (workMode === "CREATE") &&
            React.createElement(ZoneInsert, { isMobile: props.isMobile, setIsMobile: props.setIsMobile, curTree: curTree, setCurTree: props.setCurTree, setWorkMode: props.setWorkMode, setPopWin: props.setPopWin }),
        (workMode === "ADMIN_CREATE") &&
            React.createElement(ZoneInsertAdmin, { isMobile: props.isMobile, setIsMobile: props.setIsMobile, curTree: curTree, setCurTree: props.setCurTree, setWorkMode: props.setWorkMode, setPopWin: props.setPopWin }),
        (workMode === "ADMIN_COMP_CREATE") &&
            React.createElement(CompZoneInsertAdmin, { isMobile: props.isMobile, setIsMobile: props.setIsMobile, curTree: curTree, setCurTree: props.setCurTree, setWorkMode: props.setWorkMode, setPopWin: props.setPopWin })));
}
;
export default AdminZone;
